import type { Editor } from '@tiptap/react';

// --- Hooks ---
import { useTiptapEditor } from 'containers/Tiptap/hooks/use-tiptap-editor';

// --- Lib ---
import { isNodeTypeSelected, isProxyUrl } from 'containers/Tiptap/lib/tiptap-utils';

import API from 'utils/api';

// --- Tiptap UI ---
import { DeleteNodeButton } from 'containers/Tiptap/components/tiptap-ui/delete-node-button';
import { ImageDownloadButton } from 'containers/Tiptap/components/tiptap-ui/image-download-button';
import { ImageAlignButton } from 'containers/Tiptap/components/tiptap-ui/image-align-button';

// --- UI Primitive ---
import { Separator } from 'containers/Tiptap/components/tiptap-ui-primitive/separator';
import { ImageCaptionButton } from 'containers/Tiptap/components/tiptap-ui/image-caption-button';
import { ImageUploadButton } from 'containers/Tiptap/components/tiptap-ui/image-upload-button';

const resolveImageUrl = async (src: string): Promise<string> =>
  isProxyUrl(src) ? (await API.common.resolveFileUrl(src)()).data.url : src;

export function ImageNodeFloating({ editor: providedEditor }: { editor?: Editor | null }): React.ReactElement | null {
  const { editor } = useTiptapEditor(providedEditor);
  const visible = isNodeTypeSelected(editor, ['image']);

  if (!editor || !visible) {
    return null;
  }

  return (
    <>
      <ImageAlignButton align="left" />
      <ImageAlignButton align="center" />
      <ImageAlignButton align="right" />
      <Separator />
      <ImageCaptionButton />
      <Separator />
      <ImageDownloadButton resolveFileUrl={resolveImageUrl} />
      <ImageUploadButton tooltip="Replace" />
      <Separator />
      <DeleteNodeButton />
    </>
  );
}
